// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1XJLQ","filesListContainer":"PosDisputesFiles_filesListContainer__30kvr","filesButton":"PosDisputesFiles_filesButton__AmBwB"};